<mat-sidenav-container>
  <mat-sidenav #sidenav mode="over">
    <teams-nav></teams-nav>
  </mat-sidenav>
  <mat-sidenav-content>
    <div *ngIf="appConfig.initialized">
      <div class="overview-container">
        <ng-container *ngIf="pageLoaded">
          <app-eula *ngIf="!loggedInSystemUserHasLatestEula"></app-eula>
          <div
            *ngIf="loggedInSystemUserHasLatestEula"
            fxLayout="column"
            fxLayout="column"
            fxLayoutAlign=" stretch"
            fxLayoutGap="1em"
          >
            <h1 id="welcome-message-header">{{ welcomeMessage }}</h1>
            <div fxLayout="column" *ngIf="homePageWidgets.length > 0" fxLayoutGap="1em">
              <p class="widgets-update-time">All data last updated {{ widgetsUpdateDateTime | date: 'medium' }}</p>
              <div
                fxLayout="row wrap"
                fxLayout.lt-sm="column"
                fxLayoutAlign="space-between none"
                class="widget-container"
              >
                <app-upcoming-teams
                  fxFlex="32.75"
                  fxFlex.lt-lg="49"
                  (addTeam)="openAddTeamDialog()"
                  [widgetInfo]="getHomePageWidgetInfo(HOME_PAGE_WIDGETS_UI_TYPE.UpcomingTeams)"
                ></app-upcoming-teams>
                <app-recent-accepts
                  fxFlex="32.75"
                  fxFlex.lt-lg="49"
                  [widgetInfo]="getHomePageWidgetInfo(HOME_PAGE_WIDGETS_UI_TYPE.RecentlyAccepted)"
                ></app-recent-accepts>
                <app-recent-form-responses
                  fxFlex="32.75"
                  fxFlex.lt-lg="49"
                  [widgetInfo]="getHomePageWidgetInfo(HOME_PAGE_WIDGETS_UI_TYPE.RecentFormResponses)"
                >
                </app-recent-form-responses>

                <div fxFlex="32.75" fxFlex.lt-lg="49" class="widget-block">
                  <div>
                    <h2>New feature: Pages on forms</h2>
                  </div>
                  <div class="widget-contents" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <img
                      class="feature-img"
                      alt="Lineup introduces email personlization"
                      src="../assets/img/features/feat-personalization.png"
                    />
                    <div fxFlex="nogrow" class="widget-buttons">
                      <a
                        mat-button
                        color="primary"
                        target="_blank"
                        href="https://support.lineupteams.com/hc/en-us/articles/6768275059991-Supported-Merge-Tags"
                        >Learn about email personalization</a
                      >
                      <a class="all-features" mat-button href="https://www.lineupteams.com/platform"
                        >View all features</a
                      >
                    </div>
                  </div>
                </div>

                <div fxFlex="32.75" fxFlex.lt-lg="49" class="widget-block">
                  <div>
                    <h2>Join Lineup's Community</h2>
                  </div>
                  <div class="widget-contents" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <p>
                      We are happy to bring you the Lineup Client Community (LCC), a space for you and your fellow
                      Lineup users to connect.<br /><br />
                      Come on over and join the conversation with questions like, "How are some of you capturing
                      availability?" or "Any suggestions for raising form response metrics?"<br /><br />
                      Thank you and we look forward to seeing you in the LCC!
                    </p>
                    <div fxFlex="nogrow" class="widget-buttons">
                      <a
                        mat-button
                        color="primary"
                        target="_blank"
                        href="https://support.lineupteams.com/hc/en-us/community/topics"
                        >Go to the community now</a
                      >
                    </div>
                  </div>
                </div>

                <div fxFlex="32.75" fxFlex.lt-lg="49" class="widget-block">
                  <div>
                    <h2>Recent Updates</h2>
                  </div>
                  <div class="widget-contents" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="update-block" fxFlex="25">
                      <h4>
                        <a
                          class="update-link"
                          target="_blank"
                          href="https://support.lineupteams.com/hc/en-us/articles/32432745545239/"
                          >Release - May 28, 2025</a
                        >
                      </h4>
                      <p>Opportunity Board exports and more.</p>
                    </div>
                    <div class="update-block" fxFlex="25">
                      <h4>
                        <a
                          class="update-link"
                          target="_blank"
                          href="https://support.lineupteams.com/hc/en-us/articles/32432753677335-Release-Notes-May-14-2025"
                          >Release - May 14, 2025</a
                        >
                      </h4>
                      <p>Updates & bug fixes</p>
                    </div>
                    <div class="update-block" fxFlex="25">
                      <h4>
                        <a
                          class="update-link"
                          target="_blank"
                          href="https://support.lineupteams.com/hc/en-us/articles/32432736914327-Release-Notes-May-1-2025"
                          >Release - May 1, 2025</a
                        >
                      </h4>
                      <p>Opportunity Board sharing.</p>
                    </div>
                    <div class="update-block" fxFlex="25">
                      <h4>
                        <a
                          class="update-link"
                          target="_blank"
                          href="https://support.lineupteams.com/hc/en-us/articles/32432681358103-Release-Notes-April-29-2025"
                          >Release - April 29, 2025
                        </a>
                      </h4>
                      <p>Updates & bug fixes.</p>
                    </div>
                    <div fxFlex="nogrow" class="widget-buttons">
                      <a
                        mat-button
                        color="primary"
                        target="_blank"
                        href="https://support.lineupteams.com/hc/en-us/sections/360006008474-Release-Notes"
                        >View all release notes</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
